import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useCallback } from 'react';
import { css, styled } from 'styled-components';
import { onEnterOrSpacePress } from '@hivebrite/utils';
import { Box } from '@design-system/box';
import { CATEGORIES, FontAwesomeIcon } from '@design-system/font-awesome-icon';
import { s__ } from '@design-system/i18n';
import { focusOutline } from '@design-system/theme';
const CloseIcon = () => (_jsx(FontAwesomeIcon, { height: "16px", iconName: "xmark", iconType: CATEGORIES.SOLID }));
export const ClearableIconWrapper = forwardRef(({ iconPaddingValue, onChange, themeInput, variant }, ref) => {
    const handleClear = useCallback((e) => {
        var _a;
        const el = ref === null || ref === void 0 ? void 0 : ref.flatpickr;
        e.preventDefault();
        e.stopPropagation();
        if (el) {
            el.clear();
            (_a = el.input.nextElementSibling) === null || _a === void 0 ? void 0 : _a.classList.add('empty');
        }
        onChange === null || onChange === void 0 ? void 0 : onChange('');
    }, [onChange, ref]);
    return (_jsx(IconWrapper, { "$iconIsClickable": true, "$iconPaddingValue": iconPaddingValue, "$rightIcon": true, "aria-label": s__('Accessibility|Clean this input value'), height: themeInput.iconSize, onClick: handleClear, onKeyDown: onEnterOrSpacePress(handleClear), role: "button", tabIndex: 0, variant: variant, width: themeInput.iconSize, children: _jsx(CloseIcon, {}) }));
});
export const StaticIconWrapper = ({ IconComponent, iconPaddingValue, themeInput, variant, }) => (_jsx(IconWrapper, { "$iconPaddingValue": iconPaddingValue, height: themeInput.iconSize, variant: variant, width: themeInput.iconSize, children: _jsx(IconComponent, { height: "16px", width: "100%" }) }));
const IconWrapper = styled(Box) `
  ${focusOutline}

  ${({ $iconIsClickable, $iconPaddingValue, $rightIcon, theme, variant, }) => css `
    ${$iconIsClickable
    ? `
        cursor: pointer;
        pointer-events: all;
        `
    : `
        cursor: default;
        pointer-events: none;
      `}

    color: ${theme.input[variant].iconColor};
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 50%;
    ${$rightIcon
    ? `
      right: ${$iconPaddingValue / 2}px;
      transform: translate(50%, -50%);
      `
    : `
      left: ${$iconPaddingValue / 2}px;
      transform: translate(-50%, -50%);
      `}
  `}
`;
//# sourceMappingURL=IconWrapper.js.map